import React, { useEffect, useState } from 'react'
import PitchQuestionItemView from '../component/PitchQuestionItemView'
import PitchQuestionOption from '../../PitchQuestionOption/PitchQuestionOption'

const PitchQuestionItem = ({
  questionId,
  onAddOption,
  onDeleteOption,
  onDeleteQuestion,
  choices,
  correctAnswerIndex,
  description,
  type,
  onQuestionChange,
  onSetCorrectAnswer,
  onOptionChange,
}) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    const options = (choices || []).map((choice, index) => {
      return (
        <PitchQuestionOption
          key={index}
          index={index}
          value={choice}
          type={type}
          isCorrectAnswer={correctAnswerIndex === index}
          onOptionChange={({ text }) =>
            onOptionChange({ questionId, optionIndex: index, text })
          }
          onDeleteOption={() =>
            onDeleteOption({ questionId, optionIndex: index })
          }
          onChangeCorrectAnswer={() =>
            onSetCorrectAnswer({ questionId, correctAnswerIndex: index })
          }
          onAddOption={() => onAddOption({ questionId })}
        />
      )
    })
    setOptions(options)
  }, [choices, correctAnswerIndex])

  return (
    <PitchQuestionItemView
      description={description}
      type={type}
      onDeleteQuestion={() => onDeleteQuestion({ questionId })}
      onQuestionChange={value => onQuestionChange({ questionId, value })}
      onAddOption={() => onAddOption({ questionId })}
      isDisabled={!questionId.includes('newQuestion')}
    >
      {options}
    </PitchQuestionItemView>
  )
}

export default PitchQuestionItem



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/blocks/PitchQuestionItem/container/PitchQuestionItem.js